import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function TypeRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/type', component: Index, isProtected: true, permissions: ['type_index']},
    {path: '/type/create', component: Create, isProtected: true, permissions: ['type_create']},
    {path: '/type/edit/:id', component: Edit, isProtected: true, permissions: ['type_edit']},

  ];

  return routes;
}
